import React, { useEffect, useState } from 'react'
import { Panel, Table, Checkbox, Row, Col } from 'rsuite'
import { startLoading, doneLoading } from '../../utils/loading'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import {
  CANCEL,
  DEFAULT_ERR_MSG,
  DELETE_ERR_MSG,
  DELETE_SUCCESS_MSG,
  SAVE,
  SAVE_SUCCESS_MSG,
  SUCCESS_MSG,
} from '../../constants/msgText'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import notification from '../../utils/notification'
import { cloneDeep } from 'lodash-es'
import {
  deleteHoliday,
  getHoliday,
  saveHoliday,
  saveMainMenuPermission,
} from '../../redux/actions/adminProjectManagemant'
import EditButton from '../../components/buttons/editButton/EditButton'
import InputForm from '../../components/forms/input/InputForm'
import { Controller, useForm } from 'react-hook-form'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import moment from 'moment'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import { DD_MM_YYYY_SLASH } from '../../constants/date'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'

export default function ManageHolidayWidget({ schema: _schema, ...props }) {
  const { Column, HeaderCell, Cell } = Table
  const [formSchema, setFormSchema] = useState(_schema)
  const [editObject, setEditObject] = useState()
  const [year, setYear] = useState(0)

  const [isShowConfirm, setIsShowConfirm] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isNewEdit, setIsNewEdit] = useState(false)

  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const handleSave = async (request) => {
    startLoading()
    setIsLoading(true)
    try {
      const response = await saveHoliday(request)

      if (response) {
        setFormSchema(response)
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      // console.log('error', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsNewEdit(false)
    setEditObject({})
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (id) => {
    setIsShowConfirm(false)
    startLoading()
    setIsLoading(true)
    try {
      const response = await deleteHoliday(id, year)

      if (response) {
        console.log(response)
        setFormSchema(response)
        notification.open('success', {
          title: DELETE_SUCCESS_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DELETE_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      // console.log('error', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setEditObject({})

    setIsLoading(false)
    doneLoading()
  }

  const handleSearch = async (year) => {
    startLoading()
    setIsLoading(true)
    try {
      const response = await getHoliday(year)

      if (response) {
        setFormSchema(response)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      // console.log('error', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    let request = {
      id: editObject?.id || '',
      date: data.date,
      desc: data.desc,
    }

    handleSave(request)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      {formSchema && (
        <Panel shaded header={formSchema.header} collapsible defaultExpanded>
          {!isNewEdit ? (
            <>
              {formSchema.searchForms && (
                <Panel header={'ค้นหา'} collapsible defaultExpanded bordered>
                  <Row style={{ marginTop: -20 }}>
                    <Col xs={24} sm={24} md={8} lg={8}>
                      <InputForm
                        schema={formSchema.searchForms.year}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        onChange={(value) => {
                          setYear(value)
                        }}
                      />
                    </Col>
                  </Row>
                  <Row style={{ marginTop: 20 }}>
                    <SearchButton
                      onClick={() => {
                        handleSearch(year)
                      }}
                    ></SearchButton>
                    <CancelButton
                      onClick={() => {
                        handleSearch(0)
                      }}
                    >
                      {CANCEL}
                    </CancelButton>
                  </Row>
                </Panel>
              )}

              <Row style={{ marginTop: 20 }} align="right">
                <SaveButton
                  icon="plus"
                  style={{ marginBottom: 0, marginRight: 10 }}
                  onClick={() => {
                    setIsNewEdit(true)
                    setEditObject({})
                  }}
                >
                  เพิ่มวันหยุด
                </SaveButton>
              </Row>

              <Table
                wordWrap
                height={450}
                loading={isLoading}
                data={formSchema?.values || []}
                style={{ marginTop: '20px' }}
              >
                <Column align="center" width={100} fixed>
                  <HeaderCell>ลำดับ</HeaderCell>
                  <Cell>
                    {(_, index) => {
                      return index + 1
                    }}
                  </Cell>
                </Column>
                <Column align="center" width={160} fixed>
                  <HeaderCell>วันที่</HeaderCell>
                  <Cell dataKey={'holidayStr'} />
                </Column>
                <Column minWidth={160} flexGrow={1}>
                  <HeaderCell>คำอธิบาย</HeaderCell>
                  <Cell dataKey={'description'} />
                </Column>
                <Column align="center" width={200} fixed="right">
                  <HeaderCell>จัดการ</HeaderCell>
                  <Cell>
                    {(rowData, index) => {
                      return (
                        <>
                          <EditButton
                            onClick={() => {
                              setIsNewEdit(true)
                              setEditObject(rowData)
                            }}
                          ></EditButton>
                          <CancelButton
                            icon="trash-o"
                            onClick={() => {
                              setEditObject(rowData)
                              setIsShowConfirm(true)
                            }}
                          >
                            ลบ
                          </CancelButton>
                        </>
                      )
                    }}
                  </Cell>
                </Column>
              </Table>
            </>
          ) : (
            <>
              <Panel header={'เพิ่ม/แก้ไข'} collapsible defaultExpanded bordered>
                <Row style={{ marginTop: 10 }}>
                  <Col xs={24} sm={24} md={8} lg={8}>
                    <ErrorMessage error={errors[formSchema.inputForm.date.name]} />
                    {requiredFiled(
                      formSchema.inputForm.date.validators,
                      formSchema.inputForm.date.label
                    )}
                    <Controller
                      key={formSchema.inputForm.date.name}
                      name={formSchema.inputForm.date.name}
                      control={control}
                      defaultValue={
                        editObject?.holiday
                          ? moment(editObject?.holiday, DD_MM_YYYY_SLASH).toDate()
                          : moment().startOf('day').toDate()
                      }
                      rules={isValidators(formSchema.inputForm.date.validators)}
                      render={(props) => {
                        return (
                          <DatePickerCustom
                            {...props}
                            disabled={formSchema.inputForm.date.disabled}
                          />
                        )
                      }}
                    />
                  </Col>
                </Row>
                <Row style={{ marginTop: 10 }}>
                  <Col xs={24} sm={24} md={8} lg={8}>
                    <InputForm
                      schema={formSchema.inputForm.desc}
                      value={editObject?.description}
                      rows={3}
                      componentClass="textarea"
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                    />
                  </Col>
                </Row>
                <Row style={{ marginTop: 20 }}>
                  <SaveButton onClick={handleSubmit(onSubmit)}>{SAVE}</SaveButton>
                  <CancelButton
                    onClick={() => {
                      setIsNewEdit(false)
                      setEditObject({})
                    }}
                  >
                    {CANCEL}
                  </CancelButton>
                </Row>
              </Panel>
            </>
          )}
        </Panel>
      )}

      <ConfirmWidget
        title={`ยืนยัน`}
        show={isShowConfirm}
        detail={`ยืนยันการลบ ${editObject?.holidayStr || ''}`}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={() => handleDelete(editObject?.id)}
      />
    </>
  )
}
